var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThanks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6094 46.1719C35.8071 46.1719 45.6953 36.2837 45.6953 24.0859C45.6953 11.8882 35.8071 2 23.6094 2C11.4116 2 1.52344 11.8882 1.52344 24.0859C1.52344 36.2837 11.4116 46.1719 23.6094 46.1719Z",
    stroke: "url(#paint0_linear_2807_10255)",
    strokeWidth: 2.8653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7777 17.908V16.1406M17.4061 16.1406V17.908M15.6387 30.2797C15.6387 30.2797 17.4061 35.5818 23.5919 35.5818C29.7777 35.5818 31.5451 30.2797 31.5451 30.2797H15.6387Z",
    stroke: "url(#paint1_linear_2807_10255)",
    strokeWidth: 2.8653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2807_10255",
    x1: 9.12679,
    y1: -0.896517,
    x2: 52.0314,
    y2: 66.0854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#F3696E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A902"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2807_10255",
    x1: 18.3767,
    y1: 14.8658,
    x2: 38.5572,
    y2: 40.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#F3696E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A902"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.d7b9599621e942964ac4597fb2979ea8.svg";
export { ForwardRef as ReactComponent };